import { div, Flex } from "lqx-react";
import React from "react";

export const NotAllowed = () => {
    return <>
        <Flex row center />
        <Flex row center>
            <Container>
                Sorry, but you are not entitled to see this content
            </Container>
        </Flex>
    </>
}


const Container = div({
    marginTop: '100px',
    padding: '10px',
    border: '2px solid #052C4C !important',
    borderRadius: '10px',
});
